import { render } from "./FormBase.vue?vue&type=template&id=58e20cf9"
import script from "./FormBase.vue?vue&type=script&lang=js"
export * from "./FormBase.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rentapplication-frontend-vue/rentapplication-frontend-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__